export const UNIT_TEST = typeof process !== 'undefined' && process.env && process.env.VITEST === 'true';
export const INTEGRATION_TEST = 'Cypress' in globalThis || globalThis.localStorage?.getItem('integration') === 'true';
